// A Google sign-in on an account with 2FA hands the pending token to the
// sign-in page, which asks for the code (sessionStorage, this tab only).
const KEY = 'pending_2fa';

export function savePendingTwoFactor({ pendingToken, methods, redirect }) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ pendingToken, methods, redirect })); } catch (ignored) { /* sign in again */ }
}

export function readPendingTwoFactor() {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return p && typeof p.pendingToken === 'string' ? p : null;
  } catch (ignored) {
    return null;
  }
}

export function clearPendingTwoFactor() {
  try { sessionStorage.removeItem(KEY); } catch (ignored) { /* nothing stored */ }
}

export const safeRedirect = (path) => (
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') ? path : '/dashboard'
);
